import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import theme from './theme';
import Navbar from './components/Navbar';
import BottomNav from './components/BottomNav';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import HelpPage from './pages/HelpPage';
import NewMatchPage from './pages/NewMatchPage';
import DecksPage from './pages/DecksPage';
import MyMatchesPage from './pages/MyMatchesPage';
import MatchDetailsPage from './pages/MatchDetailsPage';
import UserPage from './pages/UserPage';
import NotificationsPage from './pages/NotificationsPage';
import TournamentsPage from './pages/TournamentsPage';
import TournamentDetailsPage from './pages/TournamentDetailsPage';
import TournamentParticipantsPage from './pages/TournamentParticipantsPage';
import TournamentBracketPage from './pages/TournamentBracketPage';
import TournamentCalendarPage from './pages/TournamentCalendarPage';
import TournamentLeaderboardPage from './pages/TournamentLeaderboardPage';
import TournamentMatchesPage from './pages/TournamentMatchesPage';
import AdminPage from './pages/AdminPage';
import AdminPlayersPage from './pages/AdminPlayersPage';
import AdminResultsPage from './pages/AdminResultsPage';
import AdminLeaguesPage from './pages/AdminLeaguesPage';

// New Torneos Pages
import TorneosPage from './pages/torneos/TorneosPage';
import GeneralRankingPage from './pages/torneos/GeneralRankingPage';
import StoresListPage from './pages/torneos/StoresListPage';
import StoreRankingPage from './pages/torneos/StoreRankingPage';
import StoreResultsPage from './pages/torneos/StoreResultsPage';

import PrivateRoute from './components/PrivateRoute';
import { Box } from '@mui/material';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <Box sx={{ 
          minHeight: '100vh', 
          bgcolor: 'background.default',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <CssBaseline />
          <Navbar />
          <Box sx={{ 
            flex: 1,
            pt: '64px', 
            pb: '56px',
            bgcolor: 'background.default'
          }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/help" element={<HelpPage />} />
              
              {/* Protected Routes */}
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <ProfilePage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/new-match"
                element={
                  <PrivateRoute>
                    <NewMatchPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/decks"
                element={
                  <PrivateRoute>
                    <DecksPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-matches"
                element={
                  <PrivateRoute>
                    <MyMatchesPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/match/:id"
                element={
                  <PrivateRoute>
                    <MatchDetailsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/user/:id"
                element={
                  <PrivateRoute>
                    <UserPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/notifications"
                element={
                  <PrivateRoute>
                    <NotificationsPage />
                  </PrivateRoute>
                }
              />
              {/* Tournament Routes */}
              <Route
                path="/tournaments"
                element={
                  <PrivateRoute>
                    <TournamentsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id"
                element={
                  <PrivateRoute>
                    <TournamentDetailsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/participants"
                element={
                  <PrivateRoute>
                    <TournamentParticipantsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/bracket"
                element={
                  <PrivateRoute>
                    <TournamentBracketPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/calendar"
                element={
                  <PrivateRoute>
                    <TournamentCalendarPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/leaderboard"
                element={
                  <PrivateRoute>
                    <TournamentLeaderboardPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tournaments/:id/matches"
                element={
                  <PrivateRoute>
                    <TournamentMatchesPage />
                  </PrivateRoute>
                }
              />
              {/* New Torneos Routes */}
              <Route
                path="/torneos"
                element={
                  <PrivateRoute>
                    <TorneosPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/torneos/general"
                element={
                  <PrivateRoute>
                    <GeneralRankingPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/torneos/tiendas"
                element={
                  <PrivateRoute>
                    <StoresListPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/torneos/tiendas/:storeId"
                element={
                  <PrivateRoute>
                    <StoreRankingPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/torneos/tiendas/:storeId/resultados"
                element={
                  <PrivateRoute>
                    <StoreResultsPage />
                  </PrivateRoute>
                }
              />
              {/* Admin Routes */}
              <Route
                path="/admin"
                element={
                  <PrivateRoute>
                    <AdminPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/players"
                element={
                  <PrivateRoute>
                    <AdminPlayersPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/results"
                element={
                  <PrivateRoute>
                    <AdminResultsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/leagues"
                element={
                  <PrivateRoute>
                    <AdminLeaguesPage />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Box>
          <BottomNav />
        </Box>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;